<template>
    <div class="my-learn">
        <van-nav-bar class="navBar" :title="$t('business_school.my_learning')" left-arrow  @click-left="$router.go(-1)"/>
        <div class="userinfo">
            <div class="image">
                <van-image round fit="cover" :src="$utils.setSourcePath(userInfo.headimg)"/>
            </div>
            <div class="name ellipsis">{{userInfo.firstName}} {{userInfo.lastName}}</div>
        </div>
        <div class="listItem numTotal">
            <div class="point">
                <div class="totalName">
                    <van-icon name="after-sale" />
                    <span>{{$t('text.points')}}</span>
                </div>
                <h3>{{userInfo.userPoint}}</h3>
            </div>
            <hr>
            <div class="rank">
                <div class="totalName">
                    <van-icon name="medal-o" />
                    <span>{{$t('business_school.ranking')}}</span>
                </div>
                <h3>{{userInfo.userRank}}<van-icon @click="toPage('/learn-rank')" name="arrow" /></h3>
            </div>
        </div>
        
        <div class="courseCollect">
            <div class="listItem curseList" v-for="(item,index) in myLearns" :key="index">
                <div class="header">
                    <div class="title">{{item.name}}</div>
                    <div class="more" @click="toPageList(item.name,item.curse)">
                        {{$t('business_school.all')}}<van-icon name="arrow" />
                    </div>
                </div>
                <div class="main">
                    <div class="curse" v-show="item.category!=='history'&&item.category!=='favourite'">
                        <div class="number">
                            <div class="num">{{ item.curse.length }}</div>
                            <div class="sub">{{$t('text.learned')}}</div>
                        </div>
                    </div>
                    <div class="curse" v-if="item.curse.length>0" @click="toPage('/learn-detail',{id: e.id})" v-for="(e,i) in item.curse" :key="i">
                        <van-image :src="$utils.setSourcePath(e.preview)"/>
                        <div class="tag" v-if="item.category==='history'">{{e.date}}</div>
                        <div class="title ellipsis">{{ e.title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "cases",
    components: {  },
    data() {
        return {
            userInfo: {
                userPoint: null,
                userRank: null,
                headimg: null,
                firstName: null,
                lastName: null,
            },
            myLearns: [
                {
                    name:this.$t('business_school.learning_history'),
                    category: 'history',
                    curse:[]
                },
                {
                    name:this.$t('business_school.favorite'),
                    category: 'favourite',
                    curse:[]
                },
            ],
            lang: 'en'
        }
    },

    computed: {
        
    },

    watch: {

    },

    mounted() {
        const header = JSON.parse(localStorage.getItem('header'))
        this.lang = header['Blade-Lang']
        this.getData()
    },

    methods: {
        getData(){
            this.$apis.school.getCourseFavList().then(res=>{
                this.myLearns[1].curse = res.data.list
            })
            this.$apis.school.getUserPointAndRanking().then(res=>{
                this.userInfo = Object.assign(this.userInfo, res.data)
                this.$apis.school.getCoursePointRanking({lang: this.lang}).then(res=>{
                    this.userInfo = Object.assign(this.userInfo, res.data)
                    console.log(this.userInfo);
                    
                }).catch(err => {
                    console.error(err)
                })
            })
            this.$apis.school.getCourseHistoricalRecord().then(res=>{
                this.myLearns[0].curse = res.data.records.map(item => {
                    return {
                        ...item,
                        date: item.updateTime.split(' ')[0],
                    }
                })
            })
            this.$apis.school.getMyCourseList().then(res=>{
                res.data.forEach(item => {
                    this.myLearns.push({
                        name: item.typeName,
                        category: 'course',
                        curse: item.courseList || []
                    })
                })
            }).catch(err => {
                console.error(err)
            })
            // this.$apis.school.getCourseTypeList().then(res=>{
            //     console.log(res.data.list);
            //     const promiseAll = res.data.list.map(item => {
            //         return this.$apis.school.getMyCourseList({typeId: item.id}).then(res => {
            //             this.myLearns.push({
            //                 name: item.typeName,
            //                 category: 'course',
            //                 curse: res.data.list
            //             })
            //         })
            //     })
                
            //     // res.data.list.forEach(item => {
            //     //     this.myLearns.push({
            //     //         name: item.typeName,
            //     //         category: 'course',
            //     //         curse: []
            //     //     })  
            //     // })
            // }).catch(err => {
            //     console.error(err)
            // })
        },
        toPageList(name,curses){
            console.log(name);
            if (name === this.$t('business_school.learning_history')) {
                this.$router.push('/learning-history')
            } else if (name === this.$t('business_school.favorite')) {
                this.$router.push('favourite')
            }else{
                this.$router.push('course')
                localStorage.setItem('courseList', JSON.stringify(curses))
            }
        },
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },
    },

    beforeDestroy() {
    }
}
</script>

<style lang="scss">
.my-learn {
    background: #F4F5F8;
    height: 100%;
    overflow: hidden;
    font-weight: bold;
    font-size: 14px;
    .navBar{
        background: #F4F5F8;
        height: 50px;
        line-height: 50px;
        .van-nav-bar__content{
            height: 100%;
            .van-nav-bar__arrow{
                font-size: 18px;
                color: #000;
            }
            .van-nav-bar__title{
                font-size: 18px;
                font-weight: bolder;
            }
        }
    }
    .userinfo{
        margin: 10px;
        display: flex;
        align-items: center;
        .name{
            font-size: 22px;
            font-weight: bold;
            margin-left: 10px;
        }
        .van-image{
            width: 80px;
            height: 80px;
        }
    }
    .listItem{
        margin: 0 10px 20px 10px;
        width: calc(100% - 20px);
        box-sizing: border-box;
        background: #fff;
        border-radius: 10px;
        padding: 10px;
        display: flex;
        align-items: center;
        .header{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            flex-direction: row;
            .title{
                font-size: 16px;
            }
        }
        .main{
            width: 100%;
            overflow: auto;
            display: flex;
            justify-content: flex-start;
            &::-webkit-scrollbar {
            display: none;
            }
        }
    }
    .courseCollect{
        width: 100%;
        height: calc(100% - 250px);
        overflow: auto;
        &::-webkit-scrollbar {
          display: none;
        }
    }
    .numTotal{
        height: 80px;
        padding: 0;
        justify-content: space-around;
        hr{
            margin: 0;
            width: 1px;
            height: 50%;
            border: 0;
            background: #eee;
        }
        .point,.rank{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 40%;
            h3{
                font-size: 22px;
                margin: 10px 0;
                i{
                    font-size: 14px;
                }
            }
        }
    }
    .curseList{
        min-height: 160px;
        justify-content: space-around;
        flex-direction: column;
        .curse{
            min-height: 100px;
            position: relative;
            .number{
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                min-width: 100px;
                .num{
                    line-height: 50px;
                    color: #e22f25;
                    font-size: 20px;
                    font-weight: bolder;
                }
                .sub{
                    color: #636872;
                }
            }
            .title{
                font-weight: normal;
                width: 150px;
                text-align: left;
                text-indent: 10px;
                margin-right: 5px;
            }
            .tag{
                position: absolute;
                bottom: 30px;
                left: 5px;
                background: rgba(0, 0, 0, .3);
                color: #fff;
                padding: 4px;
                border-radius: 4px;
                // font-weight: bold;
                font-size: 10px;
            }
            .van-image{
                width: 150px;
                height: 100px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/school/myLearn.vue